WiseMetering.Views.ImportIntegrations = WiseMetering.Views.Modal.Custom.extend({
    MAX_FILE_SIZE: 128 * 1024 * 1024,

    buttons: ['ok', 'cancel'],
    className: 'mbx-info text-left',
    template: 'templates/integrations/import',
    width: 760,

    events: {
        'change #file': 'onFileChange'
    },

    initialize: function(attributes) {
        // Modal.Custom hands our handlers to the modal box unbound, so `this`
        // would be the modal instead of this view when ok is clicked or the
        // title is resolved
        this.ok = this.ok.bind(this);
        this.title = this.title.bind(this);
        WiseMetering.Views.Modal.Custom.prototype.initialize.call(this, attributes);
    },

    onFileChange: function() {
        const files = this.$('#file').prop('files');
        if (files[0] && files[0].size > this.MAX_FILE_SIZE) {
            alert(i18next.t('upload_data.file_size_error', { size: this.MAX_FILE_SIZE / 1024 / 1024 }));
            this.$('#file').val('');
        }
    },

    ok: function() {
        this.modal.block();
        this.$('#errors').empty();

        const file = this.$('#file').prop('files')[0];
        if (!file) {
            this.showErrors([i18next.t('upload_data.upload_file_error')]);
            this.modal.unblock();
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        const promise = $.ajax({
            contentType: false,
            data: formData,
            processData: false,
            type: 'POST',
            url: `/integrations/import?partner_slug=${this.license.get('partner_slug')}&organization_id=${WiseMetering.currentOrganization.id}`
        });

        promise.always(() => {
            this.modal.unblock();
        });
        promise.done(data => {
            WiseMetering.layout.showTipper('success', i18next.t('integrations.import.success', { count: data.length }));
            WiseMetering.integrations.fetch();
            WiseMetering.indicators.fetch();
            // Creating integrations consumes licenses, so the counters changed
            this.license.fetch();
            this.modal.close();
        });
        promise.fail(data => {
            let json;
            try {
                json = JSON.parse(data.responseText) || {};
            } catch (error) {
                json = {};
            }

            this.showErrors(this.parseErrors(json));
        });
    },

    // The api reports up to three bad rows at once, one per line: { error: 'row 3, column site: must exist\nrow 5, ...' }
    parseErrors: function(json) {
        return typeof json.error === 'string' ? json.error.split('\n').map(line => _.escape(line)) : [i18next.t('upload_data.server_error')];
    },

    // The partner-specific bits (sample file, notes) are resolved here so the template never
    // reaches into the view or the license
    serializeData: function() {
        const slug = this.license.get('partner_slug');

        return {
            notes: Object.values(i18next.t(`integrations.import.notes.${slug}`, { returnObjects: true })),
            sampleUrl: `${WiseMetering.apiUrl}/static/example_${slug}_integrations.csv`
        };
    },

    showErrors: function(list) {
        this.$('#errors').html(list.join('<br/>') + '<br/><br/>');
    },

    title: function() {
        return i18next.t('integrations.import.title', { partner: this.license.partner().get('name') });
    }
});
